module.exports = __webpack_public_path__ + "static/media/Electricity-Usage.dcc0a5fd.jpg";